
/* SALLOGA — Stable Header Motion */

(() => {
  'use strict';

  const MAIN = '#MainContent[data-template="index"]';
  const HEADER = '#header-component[transparent]';

  let raf = 0;
  let observer = null;
  let observedHeader = null;
  let pending = null;
  let toneTimer = null;

  function overPhoto(main, x, y) {
    const layers = document.elementsFromPoint(x, y);

    const section = layers
      .filter(el => main.contains(el))
      .map(el => el.closest('.shopify-section'))
      .find(Boolean);

    if (!section) return false;

    const media = section.querySelectorAll(
      'img, video, canvas, .hero__media-grid'
    );

    for (const el of media) {
      const r = el.getBoundingClientRect();

      if (
        r.width > 20 &&
        r.height > 20 &&
        x >= r.left &&
        x <= r.right &&
        y >= r.top &&
        y <= r.bottom &&
        getComputedStyle(el).visibility !== 'hidden'
      ) {
        return true;
      }
    }

    return layers.some(el =>
      section.contains(el) &&
      getComputedStyle(el).backgroundImage !== 'none'
    );
  }

  function menuOpen(header) {
    return !!header.querySelector(
      'header-menu[aria-expanded="true"], ' +
      '.menu-list__link[aria-haspopup]:hover, ' +
      '.mega-menu__list:hover, ' +
      '.menu-drawer-container[open], details[open]'
    );
  }

  function setToneAfterStable(header, tone) {
    if (header.dataset.sallogaTone === tone) {
      clearTimeout(toneTimer);
      pending = null;
      return;
    }

    if (pending === tone) return;

    pending = tone;
    clearTimeout(toneTimer);

    toneTimer = setTimeout(() => {
      if (
        observedHeader === header &&
        pending === tone
      ) {
        header.dataset.sallogaTone = tone;
      }

      pending = null;
    }, 100);
  }

  function update() {
    raf = 0;

    const header = document.querySelector(HEADER);
    const main = document.querySelector(MAIN);

    if (!header || !main) return;

    if (observedHeader !== header) {
      observer?.disconnect();
      observedHeader = header;

      observer = new MutationObserver(schedule);

      observer.observe(header, {
        subtree: true,
        attributes: true,
        attributeFilter: [
          'aria-expanded',
          'open',
          'data-sticky-state'
        ]
      });
    }

    header.classList.add('salloga-adaptive-header');


    // Keep account icon color changes synchronized.
    const accountIcon = header.querySelector(
      '.account-button__icon'
    );

    if (accountIcon) {
      accountIcon.style.setProperty(
        'transition',
        'none',
        'important'
      );
    }


    header.classList.toggle(
      'salloga-menu-open',
      menuOpen(header)
    );

    const row = header.querySelector('.header__row--top');
    if (!row) return;

    const r = row.getBoundingClientRect();

    const y = Math.max(
      0,
      Math.min(
        innerHeight - 1,
        r.top + r.height / 2
      )
    );

    const xs = [0.18, 0.34, 0.50, 0.66, 0.82];

    const photos = xs.filter(p =>
      overPhoto(main, innerWidth * p, y)
    ).length;

    setToneAfterStable(
      header,
      photos >= 3 ? 'light' : 'dark'
    );
  }



  function schedule() {
    if (!raf) {
      raf = requestAnimationFrame(update);
    }
  }

  document.addEventListener(
    'scroll', schedule,
    { passive: true, capture: true }
  );

  document.addEventListener(
    'pointerover', schedule,
    { passive: true, capture: true }
  );

  document.addEventListener(
    'pointerout', schedule,
    { passive: true, capture: true }
  );

  document.addEventListener('focusin', schedule, true);
  document.addEventListener('focusout', schedule, true);

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);

  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      schedule,
      { once: true }
    );
  } else {
    schedule();
  }
})();
